<template>
  <div class="text-body text-black-2">
    <span v-if="inherited">
      Inherited from <RouterLink :to="inherited.link">{{ inherited.name }}</RouterLink>
    </span>
    <span v-else-if="!triggers?.length">-</span>
    <div v-else class="flex flex-col gap-4">
      <div
        v-for="trigger in [...triggers].sort((a, b) => `${a.name}`.localeCompare(`${b.name}`))"
        :key="trigger.id"
        class="flex flex-col"
      >
        <div>{{ trigger.name || "Unnamed trigger" }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { RouterLink } from "vue-router";

defineProps({
  triggers: { type: Array, default: () => [] },
  inherited: { type: Object, default: null },
});
</script>
